export const uploadStatus = Object.freeze({
  PENDING: 'pending',
  IN_PROGRESS: 'in progress',
  SUCCESS: 'success',
  ERROR: 'error',
  CANCELED: 'canceled',
})
